type ServiceLine = { name: string; label: string; text: string; id: SERVICE_LINE }

enum SERVICE_LINE {
  CFO = 'CFO',
  FULL_CHARGE_BOOKKEEPING = 'FULL_CHARGE_BOOKKEEPING',
  CPA_ACCOUNTING_ADVISORY = 'CPA_ACCOUNTING_ADVISORY',
  FPA = 'FPA',
  TAX_PREP = 'TAX_PREP',
}

export const SERVICE_LINES: Array<ServiceLine> = [
  {
    name: 'Full Charge Bookkeeping',
    label: 'Bookkeeper',
    text: 'Work directly with companies to set up, clean, maintain, and/or reconcile their books providing owners with better financial hygiene and up to date insights into their financials. Example Deliverables: Chart of Accounts, Journal Entry Posting, etc..',
    id: SERVICE_LINE.FULL_CHARGE_BOOKKEEPING,
  },
  {
    name: 'CPA/Accounting Advisory',
    label: 'Accountant',
    text: 'Overseeing the accounting process with a focus to improve the efficiency and accuracy of your clients financials (financial reports, financial metrics month end close, etc..). Relevant alternate titles could include controller and/or auditor among others.',
    id: SERVICE_LINE.CPA_ACCOUNTING_ADVISORY,
  },
  {
    name: 'FP&A',
    label: 'Financial Planner and Analyst (FP&A)',
    text: 'Helping business owners ensure the future of their business with financial modeling and KPI reporting amongst many other deep analyses. A financial analyst can help drive insights into a business.',
    id: SERVICE_LINE.FPA,
  },
  {
    name: 'CFO',
    label: 'Chief Financial Officer (CFO)',
    text: "A senior executive expected to offer financial guidance and strategy for for-profit and/or nonprofit organizations. From leading the entire finance function to longer term strategy planning to help owners keep and strengthen their financial footing. 10+ years of professional corporate finance experience. Must have held a CFO (or equivalent) title for 5+ years. Bachelor's degree in business, finance, or equivalent. MBA, CFA, and/or CPA’s are common in this role.",
    id: SERVICE_LINE.CFO,
  },
  {
    name: 'taxPreparer',
    label: 'Tax Expert',
    text: 'Prepare and file taxes for companies and individuals, as well as helping companies navigate the complexities of managing taxes through advisory-style projects. 5 + years professional tax experience, PTIN. Tax filing software(s). Secure file sharing software(s). CPA and/or EA common in this service line.',
    id: SERVICE_LINE.TAX_PREP,
  },
]
